// extracted by mini-css-extract-plugin
module.exports = {"counter":"_2PJfR","viewCount":"_1CQ7D","commentCount":"_2Al4k","replyCount":"_1jQem"};